"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";

import { createDefaultDataBindings } from "../Category/getCategoryContentBindings";

import { CATEGORY_FILTERS_INPUTS } from "./CategoryFilters.inputs.builder";

export const CategoryFilterComponent: RegisteredComponent = {
  name: "Category filters",
  component: dynamic(
    async () => (await import("./CategoryFilters")).CategoryFilters
  ),
  models: [getBuilderModelName("category")],
  defaults: {
    bindings: createDefaultDataBindings<typeof CATEGORY_FILTERS_INPUTS>({
      subcategoriesWithProductCount: "categoryFilters",
    }),
  },
  inputs: CATEGORY_FILTERS_INPUTS,
};
